import { useQuery } from '@tanstack/react-query'
import { ListLakehouseConnectionsDocument } from '@vendia/control-plane-api'
import { LakehouseConnectionInput } from '@vendia/management-api-types'
import { useParams } from 'react-router'
import { useRecoilValue } from 'recoil'

import useControlPlaneApi from './use-control-plane-api'
import { selectedRoleState } from '../state'

export const useGetLakehouseConnections = () => {
  const { id: uniName, node: nodeName } = useParams()
  const client = useControlPlaneApi()
  const selectedRoleName = useRecoilValue(selectedRoleState).name

  return useQuery({
    queryKey: ['listLakehouseConnections', { nodeName, uniName }],
    queryFn: async () => {
      const { listLakehouseConnections, errors } = await client.graphqlFetch({
        query: ListLakehouseConnectionsDocument,
        variables: {
          input: {
            nodeName: nodeName!,
            uniName: uniName!,
          },
        },
      })
      if (errors) {
        console.error(`Could not list Lakehouse connections: ${errors[0].message}`)
        return
      }
      return listLakehouseConnections as { connections: LakehouseConnectionInput[] }
    },
    enabled: Boolean(client) && Boolean(uniName) && Boolean(nodeName) && Boolean(selectedRoleName),
    staleTime: 1000 * 300, // 5 minutes
  })
}
